module.exports = __webpack_public_path__ + "img/modern.75442163.jpg";